import React, {useState, useEffect} from "react";
import { debounce } from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import ReactModal from "react-modal";
import CompatibilityCard from "../components/CompatibilityCard";
import DetailModal from "../components/DetailModal";
import ReportingModal from "../components/ReportingModal";


export default function Home() {
    
    ReactModal.setAppElement('#root');
    
    const [games, setGames] = useState([]);
    const [search, setSearch] = useState("");
    const [gamesAvailable, setGamesAvailable] = useState(true);
    const [selectedGame, setSelectedGame] = useState(null);
    const [reportingGame, setReportingGame] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const breakpoint = 600;
    
    let selectGame = (game) => {
        console.log("setting selected game: " + game.appID);
        setSelectedGame(game);
    }
    let fetchGames = async (search = "", offset = 0, count = 50) => {
        console.log("searching for: " + search)
        if(search !== "") {
            search = "&searchString=" + search;
        }
        const response = await fetch(`gamedata?offset=${offset}&count=${count}` + search);
        const data = await response.json();
        data.forEach(game => game.key = game.appid);
        if (data.length < count) {
            setGamesAvailable(false);
        }
        return data;
    }
    
    let retrieveMoreGames = async () => {
        let newGames = await fetchGames(search, games.length, 50);
        setGames(games.concat(newGames));
    }
    let searchGames = async (value) => {
        setGamesAvailable(true);
        let games = await fetchGames(value)
        setGames(games);
        setSearch(value);
    }
    
    let startGameReport = () => {
        console.log("starting game report: " + selectedGame.appID);
        setReportingGame(true);
    }

    useEffect(() => {
        window.addEventListener("resize", () => setWidth(window.innerWidth));
        retrieveMoreGames();
    }, [])
    
    let debounceSearch = debounce(searchGames, 500);
    
    return (
        <div id="wrapper">

            <header id="header" className="topnav">
                <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", flexWrap: 'wrap', margin: "0 1.5em"}}>
                        <a href="https://www.vrdesktop.net" className="logo" style={{width: 350}}>
                            <span className="title"><img src="https://static.wixstatic.com/media/e0881d_87a5403abf4a4d53b7c5b3df1202eae8~mv2.png/v1/fill/w_256,h_52,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Logo.png" alt="" /></span>
                        </a>
                        <h2 style={{textAlign: 'center'}}>Game Compatibility</h2>
                        <div className="nav" style={{width:350}}>
                            <a href="https://www.vrdesktop.net">Home</a>
                            <a href="https://www.vrdesktop.net/">FAQ</a>
                            <a href="https://games.vrdesktop.net/">Games</a>
                            <a href="http://discord.vrdesktop.net" >Discord</a>
                        </div>
                    </div>
                    <div style={{display: 'flex', justifyContent: "center"}}>
                        <input type="text" id="search" name="search" placeholder="Search Games" onChange={(e) => debounceSearch(e.target.value)} style={{minWidth: '50%', margin: width > breakpoint ? "0 25% 2.5em 25%" : "0 0 2.5em 0"}}/>
                    </div>
                </div>
            </header>

            <div id="main">
                <div className="inner">
                    <InfiniteScroll next={retrieveMoreGames} hasMore={gamesAvailable} loader={<h4>Loading</h4>} dataLength={games.length} hasChildren={true} style={{ width: '100%', overflow:'visible' }}>
                        <section className="tiles">
                            {
                                games.map((game, index) =>
                                    <CompatibilityCard game={game} id={game.appID} key={game.appID} setSelectedGame={()=> selectGame(game)}/>
                                )}
                        </section>
                    </InfiniteScroll>
                </div>
            </div>
            <DetailModal selectedGame={selectedGame} startGameReport={startGameReport} reportingGame={reportingGame} setSelectedGame={setSelectedGame}></DetailModal>
            <ReportingModal selectedGame={selectedGame} reportingGame={reportingGame} clearReportingGame={() => setReportingGame(false)} ></ReportingModal>
            
            <footer id="footer">
                <div className="inner">
                    <ul className="copyright">
                        <li>&copy; 2014-{new Date().getFullYear()} Virtual Desktop, Inc.</li>
                        <li><a href="https://www.vrdesktop.net/terms-of-service">Terms of Use</a></li>
                        <li><a href="https://www.vrdesktop.net/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </footer>

        </div>
    )
}